// Phase T2.0A Prompt 2.2 — Alternates + per-player payments API client.
// Symmetric client for both event kinds; the eventKind arg picks the URL
// prefix so the same code paths work in tournament and round-robin pages.
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

function api() {
  const token = localStorage.getItem('tl_session_token');
  return axios.create({
    baseURL: `${BASE}/api`,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

const KIND_PREFIX = {
  tournament:  { user: 'tournaments',  admin: 'admin/tournaments'  },
  round_robin: { user: 'round-robins', admin: 'admin/round-robins' },
};

function resolveKind(eventKind) {
  const k = KIND_PREFIX[eventKind];
  if (!k) throw new Error(`Unknown eventKind: ${eventKind}`);
  return k;
}

export const alternatesAPI = {
  // Member-facing
  list:   (eventKind, id)   => api().get   (`/${resolveKind(eventKind).user}/${id}/alternates`),
  join:   (eventKind, id)   => api().post  (`/${resolveKind(eventKind).user}/${id}/alternates`),
  leave:  (eventKind, id)   => api().delete(`/${resolveKind(eventKind).user}/${id}/alternates`),

  // Admin
  promote: (eventKind, id, profileId) =>
    api().post  (`/${resolveKind(eventKind).admin}/${id}/alternates/${profileId}/promote`),
  remove:  (eventKind, id, profileId) =>
    api().delete(`/${resolveKind(eventKind).admin}/${id}/alternates/${profileId}`),
};

export const paymentsAPI = {
  list:      (eventKind, id) => api().get   (`/${resolveKind(eventKind).user}/${id}/payments`),
  toggle:    (eventKind, id, profileId, paid) =>
    api().patch(`/${resolveKind(eventKind).admin}/${id}/payments/${profileId}`, { paid }),
};
